/// <reference path="../../_ext/Editors/BOMEditorDialog.ts" />

namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class StockAllocatedBOMDialog extends _Ext.BOMEditorDialog<StockAllocatedBOMRow> { 
        protected getLocalTextPrefix() { return StockAllocatedBOMRow.localTextPrefix; }
        protected getDeletePermission() { return StockAllocatedBOMRow.deletePermission; }
        protected getInsertPermission() { return StockAllocatedBOMRow.insertPermission; }
        protected getUpdatePermission() { return StockAllocatedBOMRow.updatePermission; } 
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }
    
    }
}